import { useLanguage } from "@/context/LanguageContext";
import { useSettings, waNumber } from "@/context/SettingsContext";

export const WhatsAppButton = () => {
  const { t, lang } = useLanguage();
  const { settings } = useSettings();
  const number = waNumber(settings.phone);
  const message = lang === "es"
    ? "Hola 👋, tengo una consulta sobre una joya de M&A Jewelry."
    : "Hi 👋, I have a question about an M&A Jewelry piece.";
  const href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("Chat on WhatsApp")}
      title={t("Chat on WhatsApp")}
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-[60] flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/25 transition-transform duration-300 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" style={{ animationDuration: "2.5s" }} />
      <svg viewBox="0 0 32 32" className="relative h-7 w-7 fill-current" aria-hidden="true">
        <path d="M16.001 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.256.59 4.462 1.71 6.402L3.2 28.8l6.57-1.723a12.74 12.74 0 0 0 6.23 1.586h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.052A12.72 12.72 0 0 0 16.001 3.2zm0 23.02h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.003 1.05 1.068-3.9-.252-.4a10.56 10.56 0 0 1-1.62-5.65c0-5.867 4.774-10.64 10.644-10.64a10.57 10.57 0 0 1 7.52 3.12 10.56 10.56 0 0 1 3.116 7.525c0 5.867-4.774 10.64-10.644 10.64zm5.834-7.968c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.57-1.586-.95-.847-1.592-1.894-1.779-2.214-.187-.32-.02-.493.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.734-.986-2.374-.26-.624-.523-.54-.72-.55l-.613-.011c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.667 0 1.573 1.146 3.093 1.306 3.307.16.213 2.253 3.44 5.46 4.824.763.33 1.358.526 1.822.674.766.243 1.463.209 2.014.127.615-.092 1.892-.773 2.159-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373z" />
      </svg>
    </a>
  );
};
